import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { isPhoneLineSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const mapFilterData = (data: IPhoneLineSearchForm): IPhoneLineSearchPost | {} => {
  const newData: IPhoneLineSearchForm = {...data};
  if (isPhoneLineSearchFormEmpty(data) || data == undefined) { return {} };
  
  newData.unitType = '';
  const removedUnusedFilters = filterNonEmptyValues(newData);
  return removedUnusedFilters;
}

const getPhoneLineDownloadExcel = ( {data} : {data: IPhoneLineSearchForm}): Promise<string> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;

  return axiosDefaultApi.post(`api/Search/ExportToExcel/PhoneLines?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData, header);
};

type QueryFnType = typeof getPhoneLineDownloadExcel;

type UseGetPhoneLineDownloadExcelOptions = {
  data: IPhoneLineSearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useGetPhoneLineDownloadExcel = ({ config }: UseGetPhoneLineDownloadExcelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου Excel των τηλεφωνικών γραμμών.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading Phone Line excel:', error);
    },
    onSuccess: () => {
      console.log('Phone Line report excel downloaded successfully.');
    },
    ...config,
    mutationFn: getPhoneLineDownloadExcel,
  })
}